import React, { useRef } from "react";
import { SETTINGS } from "../util/constants";
import Dropdown from "../form/Dropdown";

export default ({ setQueryVar, splitView, toggleSplitView, settings, variables }) => {
    const { hasMap } = settings;
    let textRef = useRef(variables.text);

    return (
        <div className="planner-header">
            <div className="planner-header__flex">
                <div className="planner-header__filters">
                    <form className="text-filter" onSubmit={(e) => {
                        e.preventDefault();

                        setQueryVar("text", textRef.value)
                    }}>
                        <input
                            type="text"
                            ref={(c) => (textRef = c)}
                            placeholder="Search by keyword"
                            defaultValue={variables.text}
                        />
                        <div className="text-filter__button" onClick={() => setQueryVar("text", textRef.value)}>
                            <SearchIcon />
                        </div>
                    </form>
                </div>
            </div>
            {!!hasMap && (
                <div className="planner-header__view">
                    <div
                        className={`planner-header__grid ${
                            !splitView ? "active" : ""
                        }`}
                        onClick={splitView && toggleSplitView}
                    >
                        <div>
                            <GridIcon />
                        </div>
                        <span>Grid</span>
                    </div>
                    <div className="planner-header__divider">
                        <span className="divider-black"></span>
                        <span className="divider-grey"></span>
                    </div>
                    <div
                        className={`planner-header__map ${
                            splitView ? "active" : ""
                        }`}
                        onClick={!splitView && toggleSplitView}
                    >
                        <div>
                            <MapIcon />
                        </div>
                        <span>Map</span>
                    </div>
                </div>
            )}
        </div>
    );
};

const SearchIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.905 18.905">
        <path
            id="iconmonstr-search-thin"
            fill="#fff"
            fill-rule="evenodd"
            stroke="#fff"
            stroke-width=".75"
            d="M12.265 12.795a7.129 7.129 0 1 1 .53-.53l5.58 5.58-.53.53-5.58-5.58ZM7.5 1.125A6.375 6.375 0 1 1 1.125 7.5 6.378 6.378 0 0 1 7.5 1.125Z"
        />
    </svg>
);

const MapIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19">
        <g
            id="Group_10730"
            fill="none"
            stroke="#fff"
            data-name="Group 10730"
            transform="translate(-1586 -633)"
        >
            <g
                id="Rectangle_1137"
                stroke-width="2"
                data-name="Rectangle 1137"
                transform="translate(1586 633)"
            >
                <rect width="19" height="19" stroke="none" rx="3" />
                <rect width="17" height="17" x="1" y="1" rx="2" />
            </g>
            <path
                id="Line_383"
                stroke-width="1"
                d="M1595.5 634.5v17"
                data-name="Line 383"
            />
        </g>
    </svg>
);

const GridIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <g
            id="Group_10729"
            fill="none"
            stroke="#fff"
            data-name="Group 10729"
            transform="translate(-1551 -633)"
        >
            <g
                id="Rectangle_1138"
                stroke-width="2"
                data-name="Rectangle 1138"
                transform="translate(1551 633)"
            >
                <rect width="20" height="20" stroke="none" rx="3" />
                <rect width="18" height="18" x="1" y="1" rx="2" />
            </g>
            <path
                id="Line_384"
                stroke-width="1"
                d="M1558.5 634.5v17"
                data-name="Line 384"
            />
            <path
                id="Line_385"
                stroke-width="1"
                d="M1563.5 634.5v17"
                data-name="Line 385"
            />
            <path
                id="Line_386"
                stroke-width="1"
                d="M1569.5 640.5h-17"
                data-name="Line 386"
            />
            <path
                id="Line_387"
                stroke-width="1"
                d="M1569.5 645.5h-17"
                data-name="Line 387"
            />
        </g>
    </svg>
);
